import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useRestApi } from "@/context/api";
import { useCurrentCompany } from "@/context/auth";
import { queryKeys } from "@/queries/queryKeys";
import { ImportAction, ImportSource, ImportStatus, ImportView } from "@/types/auth";

export interface UserImportsQueryParams {
  page: number;
  size: number;
  view?: ImportView;
  sources?: ImportSource[];
  statuses?: ImportStatus[];
  actions?: ImportAction[];
  from?: string;
  externalId?: string;
  hideNoChange?: boolean;
  /** Only the rows one structure file import wrote */
  batchId?: string;
}

export const useUserImportsQuery = (queryParams: UserImportsQueryParams) => {
  const { getUserImports } = useRestApi().userImports;
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.USER_IMPORTS, currentCompany.id, queryParams],
    queryFn: () => getUserImports(currentCompany.id, queryParams),
    placeholderData: keepPreviousData,
    staleTime: 30000,
  });
};
